// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseFleetPerformanceOverviewAreaRoutes = {
  route: '/fleet-performance-overview',
}

export const FleetPerformanceOverviewAreaRoutes = transformRoutes(
  BaseFleetPerformanceOverviewAreaRoutes,
)
